import { render, staticRenderFns } from "./UploadTransactionContent.vue?vue&type=template&id=3ff73eee&lang=pug"
import script from "./UploadTransactionContent.vue?vue&type=script&lang=js"
export * from "./UploadTransactionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports